import { render, staticRenderFns } from "./photo-album.vue?vue&type=template&id=4252f994&scoped=true"
import script from "./photo-album.vue?vue&type=script&lang=js"
export * from "./photo-album.vue?vue&type=script&lang=js"
import style0 from "./photo-album.vue?vue&type=style&index=0&id=4252f994&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252f994",
  null
  
)

export default component.exports